var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSweep(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mzul1dft1a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.724 8.685-2.074.608a5.036 5.036 0 0 0-3.113 2.635 4.972 4.972 0 0 0-.137 4.019l.023.053 1.72-.281a9.6 9.6 0 0 0 4.3-2.434 1 1 0 1 1 1.4 1.43 11.65 11.65 0 0 1-5.295 2.961l-1.172.194a12.772 12.772 0 0 0 2.48 2.93l2.053-.762 1.4-.7a9.544 9.544 0 0 0 3.59-3.138l.52-.761a1 1 0 1 1 1.652 1.126l-.518.761a11.535 11.535 0 0 1-4.347 3.8l-1.55.773-.843.312a13.228 13.228 0 0 0 6.694 1.8h.924c.207 0 .408-.064.578-.182a16.509 16.509 0 0 0 5.123-5.586L9.24 7.549c-.795.47-1.639.85-2.516 1.136zM24.215 2.285a1.013 1.013 0 0 0-1.43 0l-4.764 4.764-.32-.313a5.008 5.008 0 0 0-6.429-.479c-.092.066-.183.121-.276.185l10.027 9.844c.32-.864.554-1.757.7-2.666a5.028 5.028 0 0 0-1.453-4.374l-.8-.784 4.747-4.747a1.013 1.013 0 0 0-.002-1.43z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mzul1dft1a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h24v24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweep);
export default __webpack_public_path__ + "static/media/sweep.22624fc0fd039c4bb33264a3c5d3c2c7.svg";
export { ForwardRef as ReactComponent };